import React, { useState } from "react";
import { Button, Input } from "reactstrap";
import { GetChannelImage } from "src/app/shared/helpers/img-helpers/ImgHelper";
import { IContactCommunicationItemProps } from "./~types/ContactCommunicationItemProps";

import "./ContactCommunicationItem.css"
import { IMessenger } from "src/app/contact/~store/models/Messenger";

const ContactCommunicationItem = (props: IContactCommunicationItemProps) => {
    const [isEditing, setIsEditing] = useState<boolean>(props.messenger.messengerId === 0)
    const [editingMessenger, setEditingMessenger] = useState<IMessenger>({...props.messenger})

    const onChannelNameChanged = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedChannel = props.allChannels.find(ch => ch.channelId === +e.currentTarget.value)
        
        if(selectedChannel) {
            setEditingMessenger({...editingMessenger, channelId: selectedChannel.channelId, channelModel: selectedChannel});
        }
    }

    const onExternalIdChanges = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEditingMessenger({...editingMessenger, externalId: e.currentTarget.value.trim()})
    }

    const onSaveMessenger = () => {
        props.onSaveMessenger(editingMessenger);
        setIsEditing(false);
    }

    const onReplayButtonClicked = () => {
        if(props.messenger.messengerId === 0) {
            props.onDetachMessenger(props.messenger)
        }
        else {
            setIsEditing(false)
        }
    }

    const _mapChannelNameSector = () => {
        return (
            isEditing ?
                <select className="contact-communication__channel-name-select" value={editingMessenger.channelId} onChange={onChannelNameChanged}>
                    {props.allChannels.map((chnl, indx) => {
                        return(
                            <option key={indx} value={chnl.channelId}>{chnl.name}</option>
                        )
                    })}
                </select> :
                props.messenger.channelModel.name
        )
    }

    const _mapNumberSector = () => {
        return (
            isEditing ?
                <Input
                    value={editingMessenger.externalId} 
                    onChange={onExternalIdChanges}
                />:
                 props.messenger.externalId
        )
    }

    return (
        <tr key={props.messenger.messengerId}>
            <td className="contact-communication-column"> 
                {_mapChannelNameSector()}
            </td>
            <td className="contact-communication-column">
                {_mapNumberSector()}
            </td>
            <td className="contact-communication-column">
                {props.messenger.nickName}
            </td>
            <td>
                <img 
                    className="contact-messenger__icon"
                    onClick={() => isEditing ? null : props.onNewChatWithMessenger(props.messenger)}
                    src={GetChannelImage(isEditing ? editingMessenger.channelModel.type : props.messenger.channelModel.type)} 
                    width={50} 
                    height={50} />
            </td>
            <td className="contact-account-item__actions">
                {isEditing ? 
                <React.Fragment>
                    <Button
                        className="contact-account-item__btn contact-account-item__btn-save"
                        disabled={editingMessenger.externalId.trim().length === 0}
                        onClick={() => onSaveMessenger()}>
                            <i className="material-icons">save</i>
                    </Button>
                    <Button
                        className="contact-account-item__btn contact-account-item__btn-delete"
                        onClick={onReplayButtonClicked}>
                            <i className="material-icons">replay</i>
                    </Button>
                </React.Fragment> :
                <React.Fragment>
                    <Button
                        className="contact-account-item__btn contact-account-item__btn-edit"
                        onClick={() => setIsEditing(true)}>
                            <i className="material-icons">edit</i>
                    </Button>
                    <Button
                        className="contact-account-item__btn contact-account-item__btn-delete"
                        disabled={props.messengersCount === 1}
                        onClick={() => props.onDetachMessenger(props.messenger)}>
                            <i className="material-icons">delete_forever</i>
                    </Button>
                </React.Fragment>}
            </td>
        </tr>
    )
}

export default ContactCommunicationItem;